import { makeAPIRequestV2 } from '../utils/api';

// event names should be delimited by ".", e.g. track.user.upload
export function trackEvent(eventName = '', payload = {}, type = 'mixpanel') {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const {
      user: { objectId, username },
      practice,
      institution,
    } = state.login;
    const headers = { userId: objectId };
    const distinctId = username;
    const practiceIdentifier = `2.25.${institution.id}.${practice.id}`;
    const data = {
      ...payload,
      eventName,
      practiceIdentifier,
      username,
      distinct_id: distinctId,
    };

    return await makeAPIRequestV2(
      `/metrics/track/${type}`,
      { data, headers },
      'POST',
    );
  };
}
